import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TieredMenuModule } from '@openng/optimus-ui/tieredmenu';
import { MenuItem } from '@openng/optimus-ui/api';
import { ButtonModule } from '@openng/optimus-ui/button';
import { Router } from '@angular/router';
import { AuthService } from '../auth.service';

@Component({
  selector: 'app-menu',
  templateUrl: './menu.html',
  styleUrl: './menu.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [ButtonModule, TieredMenuModule],
})
export class Menu {
  items: MenuItem[] | undefined;

  constructor(
    private router: Router,
    private authService: AuthService,
  ) {}

  ngOnInit() {
    this.items = [
      {
        label: $localize`Home`,
        routerLink: '/home',
      },
      {
        label: $localize`Resibe list`,
        routerLink: '/resibelist',
      },
      {
        label: $localize`Admin`,
        items: [
          {
            label: $localize`Categoris`,
            routerLink: '/Categoris',
          },
          {
            label: $localize`Units`,
            routerLink: '/units',
          },
          {
            label: $localize`Ingredients`,
            routerLink: '/ingredients',
          },
          {
            label: $localize`Recipes`,
            routerLink: '/recipes',
          },
          {
            label: $localize`Users`,
            routerLink: '/users',
          },
          {
            label: $localize`Log out`,
            command: () => {
              this.logOut();
            },
          },
        ],
      },
    ];
  }

  isUserAuthenticated = (): boolean => {
    if (this.authService.isLoggedIn()) {
      return true;
    }

    return false;
  };

  logOut = () => {
    this.authService.logout().subscribe({
      next: () => {
        this.router.navigate(['/login']);
      },
    });
  };
}
